import { createSlice } from '@reduxjs/toolkit';

import { DatasetRelated } from '../../models/dataset/DatasetRelated';

import { emptyAction } from './actionHandler';

const categoryHookSlice = createSlice({
  name: 'categoryHook',
  initialState: null,
  reducers: {
    cancel: emptyAction<DatasetRelated>(),
  },
});

export default categoryHookSlice.actions;
